<template>
    <div class="turnkey-project-detail-page">

        <!-- 搜索弹窗 -->
        <div class="search" v-show="searchVisible">
            <div class="sc_bj">
                <div class="sc_gb" @click="toggleSearch"><i class="iconfont icon-guanbi1"></i></div>
                <div class="sc_nr">
                    <input type="text" v-model="searchKeyword" placeholder="Please enter keywords">
                    <button @click="handleSearch"><i class="iconfont icon-tubiaozhizuomoban"></i></button>
                    <div class="clear"></div>
                </div>
            </div>
        </div>

        <!-- 页面Banner -->
        <div class="ny_ban" style="background-image:url(/images/xq_ban.jpg);">
            <div class="container">
                <div class="xq_bt">
                    <!-- <font color="#ea5c1a">Qatar 2022 World Cup</font> Cattle, Sheep, and Camel Slaughter and Processing
                    Project -->
                    {{ articleDetails?.title }}
                </div>
            </div>
            <div class="dq_lm">
                <div class="container">
                    <div class="l_m"><i class="iconfont icon-dizhi1"></i>
                        <a href="/">Home</a> -
                        <a href="/turnkey_projects">Turnkey Projects</a>
                    </div>
                </div>
            </div>
        </div>

        <!-- 项目详情主体 -->
        <div class="al_xq">
            <div class="container">
                <div class="row">
                    <!-- 左侧内容区 -->
                    <div class="al_zc">
                        <!-- 项目图片轮播 -->
                        <div class="swiper-container swiper-tc" v-if="imgList.length > 0"
                             @mouseenter="pauseProjectSwiper" @mouseleave="resumeProjectSwiper">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide" v-for="(img, index) in imgList" :key="index">
                                    <img :src="`https://cdn.bosscaigou.com/${img}`">
                                    <!-- 第一张图添加播放按钮，有视频才显示 -->
                                    <div class="video-play-overlay" v-if="index === 0 && articleDetails?.video"
                                        @click="openVideoModal">
                                        <div class="play-icon-btn"><i class="iconfont icon-bofang"></i></div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-pagination"></div>
                            <div class="swiper-button-prev" @click="projectSwiper.slidePrev()"><i
                                    class="iconfont icon-zuojiantou"></i></div>
                            <div class="swiper-button-next" @click="projectSwiper.slideNext()"><i
                                    class="iconfont icon-zuojiantou"></i></div>
                        </div>

                        <!-- 视频弹窗 -->
                        <div class="video-modal" v-if="showVideoModal" @click.self="closeVideoModal">
                            <div class="modal-content">
                                <button class="close-btn" @click="closeVideoModal">&times;</button>
                                <div class="video-modal-view" style="max-width: 1280px;" v-html="nowVideo"></div>
                            </div>
                        </div>

                        <!-- 项目介绍 -->
                        <div class="xm_js">
                            <div class="b_t">Project Overview</div>
                            <!-- <div class="j_s" v-html="articleDetails?.content"></div> -->
                            <div class="j_s com-aonaer-wm-case-detail-content article-wang-editor">
                                <div ref="editorRef"></div>
                            </div>
                        </div>
                    </div>

                    <!-- 右侧侧边栏 -->
                    <div class="al_yc">
                        <!-- 项目信息 -->
                        <div class="xm_xx">
                            <div class="b_t">Project Information</div>
                            <ul>
                                <li v-for="(item, index) in (articleDetails?.info || [])" :key="index">
                                    <img :src="`/images/xm1.png`">
                                    <strong>{{ item.lb }}:</strong>
                                    <span>{{ item.vl }}</span>
                                </li>
                            </ul>
                        </div>

                        <!-- 热门项目轮播 -->
                        <div class="xm_tj">
                            <div class="b_t">Hot Projects</div>
                            <div class="swiper-container swiper-tj">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide" v-for="(item, index) in hotArticleList" :key="index">
                                        <a :href="`/case_details/${item.id}`">
                                            <img :src="`https://cdn.bosscaigou.com/${item.himg}`">
                                            <p>{{ item.title }}</p>
                                        </a>
                                    </div>
                                </div>
                                <div class="swiper-pagination"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 项目范围 -->
                <div class="xm_ld">
                    <div class="b_t">Project Scope</div>
                    <!-- <div class="j_s">{{ articleDetails?.detail }}</div> -->
                    <div class="j_s com-aonaer-wm-case-detail-content article-wang-editor">
                        <div ref="editorRef2"></div>
                    </div>
                    <ul class="row">
                        <li v-for="(item, index) in tagList" :key="index">{{ item }}</li>
                    </ul>
                </div>

                <!-- 上下篇导航 -->
                <div class="f_y">
                    <span>Prev: <a :href="lastArticle ? `/case_details/${lastArticle?.id}` : '/turnkey_projects'">{{
                        lastArticle?.title || 'No More...'
                            }}</a></span>
                    <span>Next: <a :href="nextArticle ? `/case_details/${nextArticle?.id}` : '/turnkey_projects'">{{
                        nextArticle?.title || 'No More...'
                            }}</a></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// 引入Swiper（需先安装：npm install swiper@6.x）
import Swiper from 'swiper'
// import 'swiper/swiper-bundle.css'

import { mapState } from 'vuex';
import { loadScript, jumpTo } from '@/utils/myutils';
import { listProducts, infoArticle } from '@/api';
// 1. 引入 wangEditor 核心模块和样式
// 🔥 修正1：改用命名导入（核心！）
import { createEditor, destroyEditor } from '@wangeditor/editor'
import '@wangeditor/editor/dist/css/style.css'
// XSS 过滤库
import DOMPurify from 'dompurify';

export default {
    name: 'TurnkeyProjectDetail',
    data() {
        return {
            articleDetails: {},
            lastArticle: null,
            nextArticle: null,
            // 搜索相关
            searchVisible: false,
            searchKeyword: '',
            // 语言下拉框
            languageDropdownVisible: false,
            // 移动端导航
            mobileNavVisible: false,
            // Swiper实例
            projectSwiper: null,
            hotProjectSwiper: null,

            // 视频弹窗
            showVideoModal: false,
            nowVideo: '',

            // ========== 项目详情数据 ==========
            // 项目图片轮播
            projectImages: ['2.jpg', '1.jpg', '3.jpg', '4.jpg', '5.jpg'],
            // 项目概述
            projectOverview: `To meet the high demand for premium halal meat during the FIFA World Cup Qatar 2022, we constructed a modern halal slaughtering facility in Qatar. While ensuring high precision, standardization, and full automation, the production lines were also customized to meet Qatar’s religious requirements, local customs, and traditional dietary culture. The facility not only played a crucial role in securing meat supply for athletes and event-related catering, but has since been upgraded into a permanent, modern processing center that continues to supply meat to the local market.

In November 2022, as the World Cup commenced, the slaughterhouse operated smoothly and efficiently. This project stands as a representative example of how Chinese automated slaughtering, intelligent cutting, and refrigeration technology contributed to the meat supply chain of an international mega event.`,
            // 项目基本信息
            projectInfo: [
                { icon: 'xm1.png', label: 'Location', value: 'Al Wakrah, Qatar' },
                { icon: 'xm2.png', label: 'Building Area', value: '14,000㎡' },
                { icon: 'xm3.png', label: 'Cattle line', value: '300 cattle/day' },
                { icon: 'xm3.png', label: 'Sheep line', value: '2,000 sheep/day' },
                { icon: 'xm3.png', label: 'Camel line', value: '50 camels/day' },
                { icon: 'xm4.png', label: 'Completion Time', value: 'January 2020' }
            ],
            // 热门项目
            hotProjects: [
                { id: 1, image: 'al1.jpg', title: 'Qatar 2022 World Cup Cattle, Sheep, and Camel Slaughter and Processing Project' },
                { id: 2, image: 'al1.jpg', title: 'Qatar 2022 World Cup Cattle, Sheep, and Camel Slaughter and Processing Project' },
                { id: 3, image: 'al1.jpg', title: 'Qatar 2022 World Cup Cattle, Sheep, and Camel Slaughter and Processing Project' }
            ],
            // 项目范围介绍
            projectScopeIntro: 'This was a turnkey EPC project, covering the full process from slaughtering to processing and refrigeration:',
            // 项目范围列表
            projectScopeList: [
                'Halal Slaughtering Facility',
                'Pre-slaughter handling',
                'Halal stunning and bleeding',
                'De-heading, de-hooving, skinning, and evisceration',
                'Carcass inspection, pre-cooling, and grading',
                'Intelligent Cutting & Processing Line',
                'Automated carcass transfer',
                'Precision cutting and portioning',
                'Customized product specifications',
                'Refrigeration & Cold Chain System',
                'Slaughterhouse cooling system',
                'Temperature-controlled cutting room',
                'Finished product cold storage and freezing',
                'Integration with downstream cold-chain logistics'
            ],
            // 上下篇项目
            prevProject: { id: 9, title: 'Hebei Hongdu Industrial Pork Cutting Line' },
            nextProject: { id: 11, title: 'Jilin Changling COFCO Project' }
        }
    },
    mounted() {
        // 初始化两个Swiper实例


        window.scrollTo(0, 0)

        this.infoArticleFuc();

        // 返回顶部监听
        // window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
        // 销毁Swiper实例
        if (this.projectSwiper) this.projectSwiper.destroy(true, true)
        if (this.hotProjectSwiper) this.hotProjectSwiper.destroy(true, true)
        // window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        async infoArticleFuc() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            let res = await infoArticle({
                id: this.$route.params.id || ''
            })
            loading.close();
            if (res.code == 200) {
                this.articleDetails = res.data;
                this.lastArticle = res.last || null;
                this.nextArticle = res.next || null;
                // this.initEditor();
                this.initSwipers();
                this.$nextTick(() => {
                    this.initEditor();

                })
            } else {
                this.$message.error(res.message || '获取文章详情失败');
            }
        },
        // 初始化 wangEditor（核心方法）
        initEditor() {
            // 步骤1：净化富文本内容（防止 XSS 攻击，必做）
            const safeHtml = DOMPurify.sanitize(this.articleDetails.content)
            const safeHtml2 = DOMPurify.sanitize(this.articleDetails.detail)

            // 步骤2：创建编辑器实例
            this.editor = createEditor({
                // 挂载的 DOM 元素
                selector: this.$refs.editorRef,
                // 初始内容（HTML 格式）
                html: safeHtml,
                // 配置项：仅展示模式核心配置
                config: {
                    readOnly: true, // 关键：设置为只读，禁止编辑
                    toolbarConfig: {
                        show: false // 隐藏工具栏，仅展示内容
                    },
                    // 可选：自定义样式/图片处理等
                    placeholder: 'No Project Introduction...',
                    // 禁用粘贴/拖拽等交互（仅展示场景）
                    enablePasteFilter: true,
                    enableDropFile: false
                }
            })



            this.editor2 = createEditor({
                // 挂载的 DOM 元素
                selector: this.$refs.editorRef2,
                // 初始内容（HTML 格式）
                html: safeHtml2,
                // 配置项：仅展示模式核心配置
                config: {
                    readOnly: true, // 关键：设置为只读，禁止编辑
                    toolbarConfig: {
                        show: false // 隐藏工具栏，仅展示内容
                    },
                    // 可选：自定义样式/图片处理等
                    placeholder: 'No Project Scope...',
                    // 禁用粘贴/拖拽等交互（仅展示场景）
                    enablePasteFilter: true,
                    enableDropFile: false
                }
            })

            // 步骤3：渲染编辑器
            // this.editor.render()
        },
        // ========== Swiper初始化 ==========
        initSwipers() {
            this.$nextTick(() => {

                console.log('项目图片轮播');
                // 项目图片轮播
                this.projectSwiper = new Swiper('.swiper-tc', {
                    loop: true,
                    speed: 1000,
                    navigation: {
                        nextEl: '.swiper-tc .swiper-button-next',
                        prevEl: '.swiper-tc .swiper-button-prev',
                    },
                    pagination: {
                        el: '.swiper-tc .swiper-pagination',
                        clickable: true,
                    },
                    slidesPerView: 1,
                    spaceBetween: 0,
                    autoplay: { // 可选：自动播放
                        delay: 5000,
                        disableOnInteraction: false
                    }
                })

                // 热门项目轮播
                this.hotProjectSwiper = new Swiper('.swiper-tj', {
                    loop: true,
                    speed: 1000,
                    pagination: {
                        el: '.swiper-tj .swiper-pagination',
                        clickable: true,
                    },
                    slidesPerView: 1,
                    spaceBetween: 10,
                    autoplay: {
                        delay: 4000,
                        disableOnInteraction: false
                    }
                })
            })
        },

        // ========== 搜索功能 ==========
        toggleSearch() {
            this.searchVisible = !this.searchVisible
            if (this.searchVisible) {
                this.$nextTick(() => {
                    const searchInput = document.querySelector('.sc_nr input')
                    searchInput?.focus()
                })
            }
        },

        handleSearch() {
            if (!this.searchKeyword.trim()) {
                alert('Please enter search keywords')
                return
            }
            console.log('Search:', this.searchKeyword)
            this.searchVisible = false
        },

        // ========== 语言下拉框 ==========
        toggleLanguage() {
            this.languageDropdownVisible = !this.languageDropdownVisible
        },

        // ========== 移动端导航 ==========
        toggleMobileNav() {
            this.mobileNavVisible = !this.mobileNavVisible
            document.body.style.overflow = this.mobileNavVisible ? 'hidden' : ''
        },

        // ========== 轮播悬停暂停 ==========
        pauseProjectSwiper() {
            if (this.projectSwiper && this.projectSwiper.autoplay) {
                this.projectSwiper.autoplay.stop();
            }
        },
        resumeProjectSwiper() {
            if (this.projectSwiper && this.projectSwiper.autoplay) {
                this.projectSwiper.autoplay.start();
            }
        },

        // ========== 滚动相关 ==========
        handleScroll() {
            // 可添加滚动时的样式变化逻辑
        },

        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        },

        // ========== 视频弹窗 ==========
        openVideoModal() {
            const video = this.articleDetails?.video;
            if (!video) {
                this.$message({
                    message: 'There is no video for this case at the moment!',
                    type: 'error'
                });
                return;
            };
            this.nowVideo = video;
            this.showVideoModal = true;
            this.$nextTick(() => {
                const videoEl = this.$refs.modalVideo;
                if (videoEl) {
                    videoEl.play().catch(err => {
                        console.log('自动播放失败，需要用户手动点击:', err);
                    });
                }
            });
        },
        closeVideoModal() {
            this.showVideoModal = false;
            const videoEl = this.$refs.modalVideo;
            if (videoEl) {
                videoEl.pause();
                videoEl.currentTime = 0;
            }
        }
    },
    computed: {
        hotArticleList() {
            let t = [];
            this.lastArticle && t.push(this.lastArticle);
            this.nextArticle && t.push(this.nextArticle);
            return t;
        },
        imgList() {
            return this.articleDetails?.img == null || this.articleDetails?.img == '' ? [] : this.articleDetails?.img.split(',');
        },
        tagList() {
            return this.articleDetails?.tag == null || this.articleDetails?.tag == '' ? [] : this.articleDetails?.tag.split('，');
        }
    }
}
</script>

<style scoped>
/* 引入原有样式 */

/* 视频播放按钮覆盖层 */
.video-play-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    background: rgba(0, 0, 0, 0.15);
    transition: background 0.3s ease;
}

.video-play-overlay:hover {
    background: rgba(0, 0, 0, 0.35);
}

.play-icon-btn {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 40px;
    transition: all 0.3s ease;
}

.video-play-overlay:hover .play-icon-btn {
    background: rgba(0, 0, 0, 0.7);
    transform: scale(1.1);
}

/* 视频弹窗样式 */
.video-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    padding: 15px;
    box-sizing: border-box;
}

.modal-content {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    background: unset !important;
    justify-content: center;
}

.modal-content video {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
    display: block;
}

.video-modal-view {
    width: 1000px;
    height: 80%;
}

.close-btn {
    position: absolute;
    top: 25px;
    right: 25px;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    border: none;
    width: 44px;
    height: 44px;
    line-height: 44px;
    border-radius: 50%;
    font-size: 26px;
    cursor: pointer;
    z-index: 10;
    display: flex;
    text-align: center;
    justify-content: center;
}

.close-btn:hover {
    background: #f30;
}

.icon-bofang {
    font-size: 40px;
}

@media (max-width: 768px) {
    .video-modal-view {
        width: 100%;
        height: 35%;
    }

    .play-icon-btn {
        width: 50px;
        height: 50px;
        font-size: 26px;
    }
}

</style>